/**
 * Duck para pegar pedidos
 * @author Otávio Bastilho
 * @copyright 08/2019
 */

import { createActions, createReducer } from "reduxsauce";

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
		getOrdersAsync: ['orderList'],
		getOrdersAsyncLoading: [],
		getOrdersAsyncError: [],
		getOrdersAsyncHasMoreLoading: [],
		getOrdersAsyncLoadingDownload: [],
		getOrdersAsyncDownload: ['orderListDownload'],
		getEventsLog: [],
		setSelectedOrder: [],
		unsetSelectedOrder: [],
		setOrderLoading: [],
		redirectToSubcontractorInvoiceDetails: [],
		setOrderById: [],
		unsetOrderById: [],
		setOrderByIdLoading: [],
		setNewOrderToast: [],
		setDetailedReport: [],
		setLoadingDetailedReport: [],
		setEventsLog: [],
		setLoadingEventsLog: [],
		setEventsLogToast: [],
		setRestoSobra: [],
		unsetRestoSobra: [],
		setRestoSobraLoading: [],
		setRestoSobraLoadingSave: [],
		setRestoSobraToast: [],
});

/**
 * Handlers
 */
const INITIAL_STATE = {
	orderList: [],
	page: 0,
	hasMore: true,
	hasMoreIsLoading: false,
	isLoading: false,
	error: undefined,
	isLoadingDownload: false,
	orderListDownload: [],
	selectedOrder: {
        id: null,
        data: {}
    },
	isLoadingOrder: false,
	redirectToInvoiceDetails: false,
	order: {},
	isLoadingOrderById: false,
	newOrderToast: {
        showToast: false,
        message: '',
        messageType: 'toast-success'
    },
	detailedReport: [],
	loadingDetailedReport: false,
	eventsLog: [],
	loadingEventsLog: false,
	restoSobra: {},
	isLoadingRestoSobra: false,
	isLoadingRestoSobraSave: false,
	restoSobraToast: { showToast: false, messageType: "toast-error", message: ""},
	eventsLogToast: { showToast: false, messageType: "toast-error", message: ""},
};

const getOrders = (state = INITIAL_STATE, action) => {
	return {
		...state, 
		isLoading: false, 
		error: undefined, 
		orderList: action.payload.page > 1
									? [ ...state.orderList, ...action.payload.data ] 
									: action.payload.data , 
		page: action.payload.hasMore ? action.payload.page : state.page ,
		hasMore: action.payload.hasMore,
		hasMoreIsLoading: false,
		orderListDownload: [],
	};
}

const getOrdersLoading = (state = INITIAL_STATE) => {
	return {...state, isLoading: true, error: undefined };
}

const getOrdersHasMoreLoading = (state = INITIAL_STATE) => {
	return {...state, hasMoreIsLoading: true, error: undefined };
}

const getOrdersError = (state = INITIAL_STATE, action) => {
	return {...state, isLoading: false, error: action.payload };
}

const getOrdersLoadingDownload = (state = INITIAL_STATE) => {
	return {...state, isLoadingDownload: true };
}

const getOrdersDownload = (state = INITIAL_STATE, action) => {
	return {
		...state, 
		isLoadingDownload: false,
		orderListDownload: action.payload.page > 1
									? [ ...state.orderListDownload, ...action.payload.data ] 
									: action.payload.data , 
	};
}

const setSelectedOrder = (state = INITIAL_STATE, action) => {
    return { ...state, selectedOrder: action.payload };
}

const unsetSelectedOrder = (state = INITIAL_STATE, action) => {
    return { ...state, selectedOrder: action.payload };
}

const setOrderLoading = (state = INITIAL_STATE, action) => {
    return { ...state, isLoadingOrder: action.payload };
}

const redirectToSubcontractorInvoiceDetails = (state = INITIAL_STATE, action) => {
    return { ...state, redirectToInvoiceDetails: action.payload };
}

const setOrderById = (state = INITIAL_STATE, action) => {
    return { ...state, order: action.payload };
}

const unsetOrderById = (state = INITIAL_STATE) => {
    return { ...state, order: {} };
}

const setOrderByIdLoading = (state = INITIAL_STATE, action) => {
    return { ...state, isLoadingOrderById: action.payload };
}

const setNewOrderToast = (state = INITIAL_STATE, action) => {
    return {
        ...state, 
        newOrderToast: {
            showToast: action.payload.showToast,
            message: action.payload.message,
            messageType: action.payload.messageType
        }
    };
}

const setDetailedReport = (state = INITIAL_STATE, action) => {
    return { ...state, detailedReport: action.payload };
}

const setLoadingDetailedReport = (state = INITIAL_STATE, action) => {
    return { ...state, loadingDetailedReport: action.payload };
}

const setEventsLog = (state = INITIAL_STATE, action) => {
	return { ...state, eventsLog: action.payload}
}

const setLoadingEventsLog = (state = INITIAL_STATE, action) => {
	return { ...state, loadingEventsLog: action.payload}
}

const setEventsLogToast = (state = INITIAL_STATE, action) => {
	return { ...state, eventsLogToast: action.payload}
}

const setRestoSobra = (state = INITIAL_STATE, action) => {
    return { ...state, restoSobra: action.payload };
}

const unsetRestoSobra = (state = INITIAL_STATE) => {
    return { ...state, restoSobra: {} };
}

const setRestoSobraLoading = (state = INITIAL_STATE, action) => {
    return { ...state, isLoadingRestoSobra: action.payload };
}

const setRestoSobraLoadingSave = (state = INITIAL_STATE, action) => {
    return { ...state, isLoadingRestoSobraSave: action.payload };
}

const setRestoSobraToast = (state = INITIAL_STATE, action) => {
    return { ...state, restoSobraToast: action.payload };
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
	[Types.GET_ORDERS_ASYNC]: getOrders,
	[Types.GET_ORDERS_ASYNC_LOADING]: getOrdersLoading,
	[Types.GET_ORDERS_ASYNC_ERROR]: getOrdersError,
	[Types.GET_ORDERS_ASYNC_HAS_MORE_LOADING]: getOrdersHasMoreLoading,
	[Types.GET_ORDERS_ASYNC_LOADING_DOWNLOAD]: getOrdersLoadingDownload,
	[Types.GET_ORDERS_ASYNC_DOWNLOAD]: getOrdersDownload,
	[Types.SET_SELECTED_ORDER]: setSelectedOrder,
	[Types.UNSET_SELECTED_ORDER]: unsetSelectedOrder,
	[Types.SET_ORDER_LOADING]: setOrderLoading,
	[Types.REDIRECT_TO_SUBCONTRACTOR_INVOICE_DETAILS]: redirectToSubcontractorInvoiceDetails,
	[Types.SET_ORDER_BY_ID]: setOrderById,
	[Types.UNSET_ORDER_BY_ID]: unsetOrderById,
	[Types.SET_ORDER_BY_ID_LOADING]: setOrderByIdLoading,
	[Types.SET_NEW_ORDER_TOAST]: setNewOrderToast,
	[Types.SET_DETAILED_REPORT]: setDetailedReport,
	[Types.SET_LOADING_DETAILED_REPORT]: setLoadingDetailedReport,
	[Types.SET_EVENTS_LOG]: setEventsLog,
	[Types.SET_LOADING_EVENTS_LOG]: setLoadingEventsLog,
	[Types.SET_RESTO_SOBRA]: setRestoSobra,
	[Types.UNSET_RESTO_SOBRA]: unsetRestoSobra,
	[Types.SET_RESTO_SOBRA_LOADING]: setRestoSobraLoading,
	[Types.SET_RESTO_SOBRA_LOADING_SAVE]: setRestoSobraLoadingSave,
	[Types.SET_RESTO_SOBRA_TOAST]: setRestoSobraToast,
	[Types.SET_EVENTS_LOG_TOAST]: setEventsLogToast
});
